// extracted by mini-css-extract-plugin
export default {"appbutton":"AppMenu_appbutton__AQgJ4","appmenutext":"AppMenu_appmenutext__sl7wf","appmenutextdisabled":"AppMenu_appmenutextdisabled__DKRcy","status":"AppMenu_status__3u0tl"};